<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : model.pkid ? '编辑' : '新建'"
      width="1000px"
      class="adaptationModal"
      @close="$reset('form')">
    <el-form
        ref="form"
        :disabled="disabled"
        :model="model"
        :rules="ruleValidate"
        class="form"
        label-width="120px">
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col :span="12">
          <el-form-item label="流水单名称" prop="flowSheetName">
            <el-input v-model.trim="model.flowSheetName" placeholder="请输入流水单名称"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="流水单模块名称" prop="flowSheetTemplateName">
            <el-input v-model.trim="model.flowSheetTemplateName" placeholder="请输入流水单模块名称"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">流水单明细</div>
      <el-button type="primary" style="margin-bottom: 8px" @click="$refs.detailEdit.open(null,-1)">添加</el-button>
      <el-table border :data="model.details" style="width: 100%">
        <el-table-column prop="fieldType" label="类型" width="130">
          <template slot-scope="scope">
            <span v-if="scope.row.fieldType === 10">订单表头</span>
            <span v-else-if="scope.row.fieldType === 20">订单物料</span>
            <span v-else-if="scope.row.fieldType === 30">物料特性</span>
            <span v-else-if="scope.row.fieldType === 40">序列类物料特性</span>
            <span v-else-if="scope.row.fieldType === 50">组合型序列类特性</span>
            <span v-else-if="scope.row.fieldType === 60">物料特性(忽略特殊字符)</span>
            <span v-else-if="scope.row.fieldType === 70">物料特性(审批意见)</span>
          </template>
        </el-table-column>
        <el-table-column prop="sheetName" label="SHEET名称" width="120" show-overflow-tooltip/>
        <el-table-column prop="materialName" label="物料名称" show-overflow-tooltip/>
        <el-table-column prop="fieldName" label="字段名称" width="180" show-overflow-tooltip/>
        <el-table-column prop="fieldParam" label="字段参数" width="100" align="center"/>
        <el-table-column prop="excelRow" label="行" width="60" align="center"/>
        <el-table-column prop="excelColumn" label="列" width="60" align="center"/>
        <el-table-column width="120" label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="primary" @click="$refs.detailEdit.open(scope.row, scope.$index)">编辑</el-button>
            <el-button type="danger" @click="model.details.splice(scope.$index, 1)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
    <detail-edit ref="detailEdit" @save-success="getDetail"/>
  </el-dialog>
</template>

<script>
  import DetailEdit from "./DetailEdit.vue";
  export default {
    components: { DetailEdit },

    data() {
      return {
        submitLoading: false,
        disabled: false,
        dialogVisible: false,
        model: {
          pkid: 0,
          flowSheetName: "",
          flowSheetTemplateName: "",
          details: [],
        },
        ruleValidate: {
          flowSheetName: { required: true, message: "请输入流水单名称", trigger: "blur" },
          flowSheetTemplateName: { required: true, message: "请输入流水单模块名称", trigger: "blur" },
        },
      };
    },

    methods: {
      open(row, mark) {
        this.dialogVisible = true;
        this.disabled = mark;
        if (row) {
          this.model = Object.assign(this.model, row);
        }
      },

      getDetail(data) {
        console.log(data);
        console.log(this.model.details);
        if (data.index === -1) {
          this.model.details.push(JSON.parse(data.data));
        } else {
          this.$set(this.model.details, data.index, JSON.parse(data.data));
        }
      },

      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$http
              .save("basic", "flowSheetConfigs", this.model)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
